import { styled } from "@mui/material/styles";
import { Chip } from "@mui/material";

const CustomChip = styled(Chip)({
    
    fontSize:12,
});

export { CustomChip };
